<template>
  <div>
    <div class="page-title">通知 Announcement Detail</div>
    <el-card class="box-card">
      <el-button class="info-button-class" @click="onBack" type="info"
        >返回 Back</el-button
      >
      <announcementFrom
        :announcementDetail="announcementDetail"
      ></announcementFrom>
      <el-button
        type="info"
        v-if="announcementDetail.type == 1"
        @click="onSubmit"
        >提交 Submit</el-button
      >
    </el-card>

    <div class="copyright-card">
      <copyrightCard></copyrightCard>
    </div>
  </div>
</template>

<script>
import {
  getAnnouncementDetail,
  replyOfferRequests,
  readRequest,
} from "@/api/parent/notification";
import copyrightCard from "@/components/copyrightCard";
import announcementFrom from "./components/announcementFrom";
export default {
  components: { copyrightCard, announcementFrom },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      announcementDetail: {},
    };
  },
  created() {
    this.getAnnouncementDetail();
    this.readRequest();
  },
  methods: {
    onSubmit() {
      this.replyOfferRequests();
    },
    replyOfferRequests() {
      let from = {
        responseType: this.announcementDetail.replyType,
        delegateName: this.announcementDetail.DelegateName,
        delegateHkid: this.announcementDetail.DelegateHkid,
      };
      replyOfferRequests(this.id, from).then(() => {
        this.$message.success("send success");
        this.onBack();
      });
    },
    readRequest() {
      readRequest(this.id).then(() => {});
    },
    getAnnouncementDetail() {
      getAnnouncementDetail(this.id).then((v) => {
        this.announcementDetail = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-title {
  color: #337ab7;
  font-weight: bold;
  font-size: 25px;
  margin-bottom: 30px;
}
.box-card {
  margin-bottom: 30px;
}
.copyright-card {
  background-color: #fff;
}
.el-button--info {
  width: auto;
  text-align: right;
}
.info-button-class {
  margin-bottom: 20px;
  margin-left: auto;
}
</style>